import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2, Zap, Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/call');
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="w-full max-w-md" data-testid="login-page">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'var(--accent-primary)' }}>
              <Zap size={22} className="text-white" />
            </div>
            <span className="text-xl font-heading font-bold" style={{ color: 'var(--text-primary)' }}>
              SalesAI <span className="font-mono text-sm" style={{ color: 'var(--text-muted)' }}>COPILOT</span>
            </span>
          </div>
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
            Inicia sesion para continuar
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="rounded-xl border p-6 space-y-5" style={{ backgroundColor: 'var(--surface-primary)', borderColor: 'var(--border-color)' }}>
          {error && (
            <div className="p-3 rounded-lg text-sm font-medium bg-red-500/10 text-red-400 border border-red-500/20" data-testid="login-error">
              {error}
            </div>
          )}

          <div>
            <label className="block text-xs font-medium mb-1.5" style={{ color: 'var(--text-secondary)' }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              data-testid="login-email"
              required
              autoFocus
              className="w-full px-4 py-2.5 rounded-lg border text-sm outline-none transition-all focus:ring-2"
              style={{
                backgroundColor: 'var(--surface-secondary)',
                borderColor: 'var(--border-color)',
                color: 'var(--text-primary)',
              }}
              placeholder="tu@email.com"
            />
          </div>

          <div>
            <label className="block text-xs font-medium mb-1.5" style={{ color: 'var(--text-secondary)' }}>Contraseña</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                data-testid="login-password"
                required
                className="w-full px-4 py-2.5 pr-10 rounded-lg border text-sm outline-none transition-all focus:ring-2"
                style={{
                  backgroundColor: 'var(--surface-secondary)',
                  borderColor: 'var(--border-color)',
                  color: 'var(--text-primary)',
                }}
                placeholder="Tu contraseña"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2"
                style={{ color: 'var(--text-muted)' }}
              >
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full py-2.5 rounded-lg text-sm font-semibold text-white transition-all flex items-center justify-center gap-2"
            style={{ backgroundColor: loading ? '#4f46e5' : 'var(--accent-primary)' }}
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : null}
            {loading ? 'Iniciando sesion...' : 'Iniciar Sesion'}
          </button>

          <div className="text-center">
            <Link
              to="/forgot-password"
              className="text-xs font-medium transition-colors hover:underline"
              style={{ color: 'var(--accent-primary)' }}
              data-testid="forgot-password-link"
            >
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
